<template>
  <div class="centered-video row-190-40">
    <WidgetVideo
      class="is-cover"
      :videoPreview="props.data.videoPreview"
      :fullVideo="props.data.videoFull"
      :showPlayButton="true"
      :playInViewport="true"
    />
  </div>
</template>

<script>
export default {
  name: 'PagesCommonCenteredVideo',
}
</script>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<style lang="scss">
@import './style.scss';
</style>